<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1">
          <div class="primary--text">Advanced Search</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs4>
          <div class="caption">Staff ID</div>
          <input type="text" v-model="filter.staff_id" />
        </v-flex>
        <v-flex xs4 class="px-2">
          <div class="caption">First name</div>
          <input type="text" v-model="filter.first_name" />
        </v-flex>
        <v-flex xs4>
          <div class="caption">Last name</div>
          <input type="text" v-model="filter.last_name" />
        </v-flex>
        <v-flex xs4 class="pt-2">
          <div class="caption">แผนก</div>
          <multiselect
            v-model="filter.department"
            track-by="engname"
            label="engname"
            :options="departmentMasterData"
            :allow-empty="true"
            :searchable="false"
            selectLabel
            :max-height="150"
            open-direction="bottom"
          ></multiselect>
        </v-flex>
        <v-flex xs4 class="px-2 pt-2">
          <div class="caption">สังกัด</div>
          <div>
            <multiselect
              v-model="filter.affiliation"
              track-by="engname"
              label="engname"
              :options="affiliationMasterData"
              :allow-empty="true"
              :searchable="false"
              selectLabel
              :max-height="150"
              open-direction="bottom"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs4 class="pt-2">
          <div class="caption">Status</div>
          <div>
            <multiselect
              v-model="filter.status"
              track-by="engname"
              label="engname"
              :options="statusMasterData"
              :allow-empty="true"
              :searchable="false"
              selectLabel
              :max-height="150"
              open-direction="bottom"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs4 class="pt-3">
          <div class="caption">Probation Level</div>
          <div>
            <multiselect
              v-model="filter.probation_level"
              :options="probation_level_options"
              :allow-empty="true"
              :searchable="false"
              selectLabel
              :max-height="150"
              open-direction="top"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs4 class="px-2 pt-3">
          <div class="caption">SOP Pass/Fail</div>
          <div>
            <multiselect
              v-model="filter.sop_status"
              :options="sopStatus_options"
              :allow-empty="true"
              :searchable="false"
              selectLabel
              :max-height="150"
              open-direction="top"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn @click="clearSearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onSearch" color="primary">Search</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import hopinnHrApi from '@/api/hopinn-hr'
const initialFilter = {
  staff_id: '',
  first_name: '',
  last_name: '',
  department: '', //แผนก
  position: '', //ตำแหน่ง
  affiliation: '', //สังกัด
  status: '',
  probation_level: '',
  sop_status: ''
}
export default {
  props: [
    'statusMasterData',
    'divisionMasterData',
    'departmentMasterData',
    'affiliationMasterData',
    'positionMasterData'
  ],
  components: {
    Multiselect
  },
  async mounted() {
    await this.handleGetDepartmentOptions()
  },
  data() {
    return {
      filter: { ...initialFilter },
      department_options: [],
      office_options: ['สำนักงานใหญ่', 'โรงแรม', 'โรงแรมเฟรนไชส์'],
      probation_level_options: ['High', 'Beginner', 'Intermediate'],
      sopStatus_options: ['Pass', 'Fail']
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      this.$emit('onSearch', this.filter)
    },
    async handleGetDepartmentOptions() {
      const vm = this
      const departmentResponse = await hopinnHrApi.getDepartment()
      const tempDepartmentOptions = []
      departmentResponse.data.data.forEach((item) => {
        tempDepartmentOptions.push(item.engname)
      })
      if (tempDepartmentOptions) vm.department_options = tempDepartmentOptions
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/SearchEmployeeDialog.vue